import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#1A1A2E] border-t border-[#E2E8F0]">
      <div className="px-6 md:px-12 lg:px-24 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          {/* Brand */}
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-4">
              <img src="/logo.png" alt="K10 Properties Group" className="h-16 w-auto brightness-0 invert" />
            </div>
            <p className="text-white/60 text-sm leading-relaxed max-w-sm">
              Premium short-term rental experiences. Every property is hand-selected to deliver exceptional stays for discerning travelers.
            </p>
          </div>

          {/* Links */}
          <div className="md:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.2em] text-white/40 mb-6">Navigate</h4>
            <div className="flex flex-col gap-3">
              {[
                { to: "/", label: "Home" },
                { to: "/properties", label: "Properties" },
                { to: "/about", label: "About" },
                { to: "/contact", label: "Contact" },
              ].map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="text-white/60 hover:text-white text-sm transition-colors duration-200"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div className="md:col-span-4">
            <h4 className="text-xs uppercase tracking-[0.2em] text-white/40 mb-6">Contact</h4>
            <div className="flex flex-col gap-3 text-sm text-white/60">
              <span className="text-white/70 text-xs">Managed by Bergrand Realty</span>
              <span>rick@bergrand.com</span>
              <span>(231) 221-2323</span>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-white/40 text-xs tracking-wider">
            &copy; {new Date().getFullYear()} K10 Properties Group. All rights reserved.
          </p>
          <Link
            to="/admin/login"
            data-testid="footer-admin-login"
            className="text-white/30 text-xs hover:text-white/60 transition-colors tracking-wider"
          >
            Admin Login
          </Link>
        </div>
      </div>
    </footer>
  );
}
